export default {
  userInfo: (state: any) => state.userInfo,
  isLogin: (state: any) => state.status.login,
  isIframe: (state: any) => state.isIframe,
};
